export default function initWork() {
    console.log("Ram...!");
    const workbannerscroller = document.querySelector('.work-banner-scroller');
    const header = document.querySelector('.header');
    if (workbannerscroller) {
        const parent = workbannerscroller.parentElement;
        let parentHeight = 0, headerHeight = 0;
        if (parent) {
            // Get the height of the parent element
            parentHeight = parent.offsetHeight;
        }
        if (header) {
            // Get the height of the parent element
            headerHeight = header.offsetHeight;
        }
        let scrollAmount = headerHeight + parentHeight;

        workbannerscroller.addEventListener('click', () => {

            console.log("vvvv");
            window.scrollBy({
                // top: 600, // Scroll vertically by 500px
                top: scrollAmount, // Scroll vertically by 500px
                left: 0,  // No horizontal scrolling
                behavior: 'smooth', // Smooth scrolling animation
            });
        });
        console.log(workbannerscroller);
    }
}